module.exports = __webpack_public_path__ + "static/img/qujian-tips-2.090f2da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qujian-tips-2.jpg
// module id = ZRzH
// module chunks = 1